import { render, staticRenderFns } from "./DataSelector.vue?vue&type=template&id=d473fb80&"
import script from "./DataSelector.vue?vue&type=script&lang=js&"
export * from "./DataSelector.vue?vue&type=script&lang=js&"
import style0 from "./DataSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports